<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="text-center">
        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
          <v-icon left>mdi-printer</v-icon>Print
          <v-icon right></v-icon>
        </v-btn>
      </div>
      <v-card class="box" flat>
        <div>
          <span style="float: right">Record No.: {{ inst_health_card_data.record_no }}</span>
          <br />
        </div>
        <!-- Health card data- {{ inst_health_card_data }} <br /><br /> -->
        <center>
          <h3 style="text-transform: uppercase">
            <b>{{ inst_health_card_data.organization_name }}</b>
          </h3>

          <h3 style="text-decoration: underline; text-transform: uppercase">
            <b>MEDICAL/HEALTH CARD FOR SCHOOL STAFF</b>
          </h3>
          <h3 style="text-transform: uppercase">
            <b>ACADEMIC YEAR -{{ inst_health_card_data.academicYear }}</b>
          </h3>
          <h3 style="text-decoration: underline; text-transform: uppercase">
            <b>SECTION -A(TO BE FILLED BY THE STAFF)</b>
          </h3>
        </center>
        <br />

        <v-row dense class="inst-details">
          <v-col cols="12" sm="6" md="6">
            <v-row dense>
              <v-col cols="12" sm="2" md="2"> Name- </v-col>
              <v-col cols="12" sm="10" md="10">
                {{ inst_health_card_data.inst_name }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-row dense>
              <v-col cols="12" sm="5" md="5"> Employee Id- </v-col>
              <v-col cols="12" sm="7" md="7">
                {{ inst_health_card_data.inst_employee_id }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-row dense>
              <v-col cols="12" sm="5" md="3"> Gender- </v-col>
              <v-col cols="12" sm="7" md="9">
                {{ inst_health_card_data.gender }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-row dense>
              <v-col cols="12" sm="2" md="2"> Residential Address- </v-col>
              <v-col cols="12" sm="10" md="10">
                {{ inst_health_card_data.address }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row dense>
              <v-col cols="12" sm="3" md="3"> Contact No.- </v-col>
              <v-col cols="12" sm="9" md="9">
                {{ inst_health_card_data.contact_no }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row dense>
              <v-col cols="12" sm="3" md="2"> Email Id- </v-col>
              <v-col cols="12" sm="9" md="10">
                {{ inst_health_card_data.email }}
                <hr />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-row dense>
              <v-col cols="12" sm="4" md="4"> Emergency Contact No.- </v-col>
              <v-col cols="12" sm="8" md="8">
                {{ inst_health_card_data.emergency_contact_number }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row dense>
              <v-col cols="12" sm="4" md="2"> Aadhar No.- </v-col>
              <v-col cols="12" sm="8" md="10">
                {{ inst_health_card_data.aadhar_no }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row dense>
              <v-col cols="12" sm="6" md="6"> Marital Status- </v-col>
              <v-col cols="12" sm="6" md="6">
                {{ inst_health_card_data.marital_status }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row dense>
              <v-col cols="12" sm="6" md="5"> Blood Group- </v-col>
              <v-col cols="12" sm="6" md="7">
                {{ inst_health_card_data.bloodgroup }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row dense>
              <v-col cols="12" sm="6" md="3"> Height- </v-col>
              <v-col cols="12" sm="6" md="9">
                {{ inst_health_card_data.height }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row dense>
              <v-col cols="12" sm="6" md="3"> Weight- </v-col>
              <v-col cols="12" sm="6" md="9">
                {{ inst_health_card_data.weight }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                Family Doctor's name & contact no.-
              </v-col>
              <v-col cols="12" sm="6" md="9">
                {{ inst_health_card_data.family_doctor_name }}&nbsp;{{
                inst_health_card_data.family_doctor_number
                }}
                <hr />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                Family History of any disease-
              </v-col>
              <v-col cols="12" sm="6" md="9">
                {{ inst_health_card_data.family_history_of_disease }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-row dense>
              <v-col cols="12" sm="4" md="2"> Allergic to- </v-col>
              <v-col cols="12" sm="8" md="10">
                {{ inst_health_card_data.allergy }}

                <hr />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-row dense>
              <v-col cols="12" sm="4" md="2">
                Any major surgery/medical emergency -</v-col>
              <v-col cols="12" sm="8" md="10">
                {{ inst_health_card_data.past_medical_surgery_emergency }}
                <hr />
              </v-col>
              <v-col cols="12" sm="4" md="2">
                Medical Fitness Certificate Submitted ?</v-col>
              <v-col cols="12" sm="8" md="10">
                {{
                inst_health_card_data.is_medical_fitness_certificate_submitted
                }}
                <hr />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <br />

      <!-- <v-card class="box" v-if="history_data.length > 0">
        <v-data-table :headers="headers" :items="history_data">
          <template v-slot:top>
            <v-toolbar flat class="toolbar no-display">
              <v-toolbar-title>Medical History</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card> -->
      <v-card class="box" flat v-if="history_data.length > 0">
        <v-toolbar flat class="toolbar no-display">
          <v-toolbar-title>Medical History</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <!-- <v-data-table :headers="headers" :items="history_data">    
 </v-data-table> -->
        <center>
          <h3 style="text-decoration: underline; text-transform: uppercase">
            <b>SECTION -b(To be filled by the school nurse / medical doctor)</b>
          </h3>
        </center>
        <br />
        <v-simple-table fixed-header dense class="elevation-1">
          <thead>
            <tr>
              <td class="text-center">Sr.No.</td>
              <td class="text-center">Date</td>
              <td class="text-center">Academicyear</td>
              <td class="text-center">Health Concern</td>
              <td class="text-center">Medication Administered</td>
              <td class="text-center">
                Name Of Attending Person /Medical Professional
              </td>
              <td class="text-center">Remark</td>
              <td class="text-center no-display">Delete Treatment</td>
            </tr>
          </thead>
          <tbody v-for="(s, index) in history_data" :key="index">
            <tr>
              <td>{{ s.count }}</td>
              <td>
                {{ s.date }}
              </td>
              <td>{{ s.academicYear }}</td>
              <td>{{ s.health_concern }}</td>
              <td>
                {{ s.medication_administered }}
              </td>
              <td>
                {{ s.name_of_medical_professional }}
              </td>
              <td>
                {{ s.remark }}
              </td>
              <td class="no-display">
                <v-avatar size="35">
                  <v-icon class="mr-4 v-icon-size" color="red" @click="deleteTreatment(s)">mdi-trash-can</v-icon>
                </v-avatar>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    inst_health_card_data: [],
    disable_approve: true,
    academicyear: "",
    medical_form_no: null,
    history_data: [],
    headers: [
      { text: "SR No", value: "count" },
      { text: "Date", value: "date" },
      { text: "Academicyear", value: "academicYear" },
      { text: "Health Concern", value: "health_concern" },
      { text: "Medication Administered", value: "medication_administered" },
      {
        text: "Name Of Attending Person /Medical Professional",
        value: "name_of_medical_professional",
      },
      { text: "Remark", value: "remark" },
    ],
  }),
  methods: {
    deleteTreatment(treatment) {
      const formData = {
        treatment_id: treatment.id,
      };
      axios
        .post("HealthCard/deleteTreatment", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.history_data = res.data.history_data;
            this.showSnackbar("green", "Treatment Deleted Successfully...");
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    print() {
      setTimeout(function () {
        window.print();
      }, 100);
    },
    // approveHealthCard(){
    //   if (!confirm("Are You Sure You Want To Approve...?")) return;
    //    const formData = {
    //       academicyear: this.academicyear,
    //     };
    //    axios
    //     .post("HealthCard/approveInstructorHealthCard",formData)
    //     .then((res) => {
    //       if (res.data.flag == "YES") {
    //         this.inst_health_card_data = res.data.health_card_data;
    //         this.overlay = false;
    //         this.showSnackbar("green", res.data.snackbar);
    //       } else {
    //         this.showSnackbar("#b71c1c", res.data.status_reason);
    //       }
    //     })
    //     .catch((error) => {
    //       this.showSnackbar("#b71c1c", "Something went wrong!!!");
    //       this.overlay = false;
    //     })
    //     .finally(() => {
    //       this.overlay = false;
    //     });
    // },
    onLoad() {
      const formData = {
        medical_form_no: this.medical_form_no,
      };
      axios
        .post("HealthCard/getInstructorHealthCardDetails", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_health_card_data = res.data.health_card_data;
            this.overlay = false;
            this.academicyear = this.inst_health_card_data.academicYear;
            this.history_data = res.data.history_data;
            // if(this.inst_health_card_data.isapproved == true){
            //   this.disable_approve=false
            // }else{
            //   this.disable_approve=true
            // }
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.medical_form_no = localStorage.getItem("medical_form_no");
    //alert("medical_form_no"+this.medical_form_no)
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.inst-details {
  text-transform: uppercase;
  font-weight: 400;
}
.inst-details span {
  /* text-decoration: underline; */
  border-bottom: 1px solid currentColor;
  display: inline-block;
}
thead,
tr,
td {
  font-weight: bold !important;
  border: 1px solid black;
  font-size: large;
  height: 50px;
}
@media print {
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  .box {
    background-color: white !important;
    border: none !important;
  }
  @page {
    size: A4;
    /* margin: -1%; */
    margin-top: -7%;
    /* margin: 0px; */
    /* size: 15in 11in; */
    size: 15in 17in;
  }
}
</style>